import React, { useState } from "react";
import { Link } from "react-router-dom";
import { authApi } from "../lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    setMessage("");
    try {
      const data = await authApi.forgotPassword(email);
      setMessage(data.message || "Ha van fiók, elküldtük a linket.");
    } catch (err) {
      setError(err.message || "Hiba történt.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 pt-24 pb-16">
      <h1 className="text-3xl font-bold mb-2">Elfelejtett jelszó</h1>
      <p className="text-gray-600 mb-8">
        Add meg az e-mail címed, és küldünk egy visszaállító linket.
      </p>
      <form onSubmit={onSubmit} className="space-y-4">
        {error && (
          <div className="rounded-lg border border-red-200 bg-red-50 text-red-800 px-3 py-2 text-sm">
            {error}
          </div>
        )}
        {message && (
          <div className="rounded-lg border border-emerald-200 bg-emerald-50 text-emerald-900 px-3 py-2 text-sm">
            {message}
          </div>
        )}
        <label className="block">
          <span className="text-sm font-medium">E-mail</span>
          <input
            type="email"
            required
            className="mt-1 w-full border rounded-lg px-3 py-2"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <button
          type="submit"
          disabled={busy}
          className="w-full bg-[#0c1a26] text-[#f5e9cb] rounded-lg py-2.5 font-medium disabled:opacity-60"
        >
          {busy ? "Küldés…" : "Link küldése"}
        </button>
      </form>
      <p className="mt-6 text-sm">
        <Link to="/bejelentkezes" className="text-blue-700 underline">
          Vissza a bejelentkezéshez
        </Link>
      </p>
    </div>
  );
}
